import { createContext } from 'react'

import { IUserContext } from './types'

export const UserContext = createContext(null as IUserContext | null)
